<template>
  <div class="app-content content " v-show="render">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
      </div>
      <div class="content-body" style="background-color: rgb(49 105 146);">
        <div class="auth-wrapper auth-v2">
          <div class="auth-inner row m-0">
            <AuthLogo/>
            <!-- Left Text-->
            <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5"><img class="img-fluid" style="max-width: 47%;"
                                                                                               :src="`${publicPath}app-assets/images/pages/illustration.png`"
                                                                                               alt="Login V2"/></div>
              <div style="position: absolute;top: 70%;">
                <h3 class="text-white">Join Us Now!</h3>
                <h3 class="text-white ">One payment solution for all your needs.</h3>
                <p class="text-white mb-0">Grow your business with us</p>
                <p class="text-white mb-0">Send and receive money with ease</p>
                <p class="text-white mb-0">Live tracking keeps you update on the go!</p>
              </div>
            </div>

            <!-- /Left Text-->
            <!-- Login-->
            <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
              <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
                <h3 class="card-title font-weight-bold mb-1"><img class="w-75" :src="`${publicPath}vaults-authlogo.png`"></h3>
                <h3 class="card-title font-weight-bold mb-1">Welcome to VaultsPay! 👋</h3>
                <p class="card-text mb-2">Please sign-in to your account and start the adventure</p>
                <form class="auth-login-form mt-2" @submit.prevent="sendCall">
                  <div class="form-group">
                    <label class="form-label">Email</label>
                    <input name="email" v-model="email"
                           :class=" errorBag.has('email') ? 'is-invalid' : ''"
                           class="form-control"
                           type="email"
                           placeholder="Email"
                           v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('email')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("email") }}</small>
                  </div>
                  <div class="form-group">
                    <label class="form-label">Password</label>
                    <input name="password" v-model="password"
                           :class=" errorBag.has('password') ? 'is-invalid' : ''"
                           class="form-control"
                           type="password"
                           placeholder="Password"
                           v-validate="'required'"
                    />
                    <small
                        v-show="errorBag.has('password')"
                        class="invalid-feedback"
                    >{{ "*" + errorBag.first("password") }}</small>
                  </div>
                  <div class="mt-2">
                    <button
                        type="submit"
                        class="btn btn-primary mr-1 d-flex"

                        :disabled="loading"
                    >
                      <Loader :loading="loading" :size="size"></Loader>
                      Sign In
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <!-- /Login-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import reCaptchaMixin from "@/mixin/reCaptchaMixin";

export default {
  mixins: [reCaptchaMixin],
  data(){
    return{
      email:'',
      password:'',
      loading: false,
      size: "10px",
      render:false,
    }
  },
  methods: {
    async sendCall() {

      this.$validator.validateAll().then(async valid => {
        if (valid) {
          this.loading = true;
          localStorage.setItem('email',this.email);


          let data = {
            email: this.email,
            password: this.password,
          }

          if(process.env.VUE_APP_ACTIVATE_RECAPTCHA == 'true'){
            try {
              const token = await this.executeRecaptcha('submit');
              this.recaptchaToken = token;

            } catch (error) {
              console.error('reCAPTCHA error:', error);
            }

            data = {
              ...data,
              verResponse: this.recaptchaToken
            }
          }




          this.makeRequest("post", "v1/login", data).then(callResponse => {
            sessionStorage.setItem('stack','');
            this.loading = false;
            if (!callResponse.error) {
              let code = callResponse.response.data.code;
              if (code == 200) {
                if (callResponse.response.data.data) {
                  let responseData = callResponse.response.data.data;
                  let requestData = {
                    row: responseData,
                    key: "login"
                  };
                  this.$store.dispatch("set", requestData);
                }


                if(callResponse.response.data.data.otpVerification == 1){
                  this.$router.push({name: 'verify-otp', params: {email: this.email}});
                }else{
                  var newUrl = window.location.href.replace('auth/login','app/');
                  window.location.href = newUrl
                }

              }
            }
          });
        }
      });
    }
  },
  beforeMount(){
    this.makeRequest('post', 'v1/get-admin-dashboard-feature', {}, {}, false,false).then(callResponse => {

      if (!callResponse.error) {
        let code = callResponse.response.data.code;

        if (code == 200) {
          var newUrl = window.location.href.replace('auth/login','app/');
          window.location.href = newUrl
        }else{
          this.render = true
        }

      }
    });



  },
}
</script>

